import { Box, Icon, View, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const StyledLogo = View.withConfig({
  height: '50px',
  width: '50px',
  marginX: 'auto',
  padding: '$1.5',
});

export const StyledBox = Box.withConfig({
  padding: '$4',
});

export const StyledActionButton = makeUclComponent(ActionButton).withConfig({
  width: {
    base: 'full',
    md: '300px',
  },
  alignSelf: 'center',
  marginTop: '$4',
});

export const StyledBackIcon = Icon.withConfig({
  color: theme.token('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});
